import AssigneeWidgetLayoutMobile from './AssigneeWidgetLayout.mobile';
import AssigneeWidgetLayoutWeb from './AssigneeWidgetLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? AssigneeWidgetLayoutMobile : AssigneeWidgetLayoutWeb;
